function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.635 18.03H5.406a.2.2 0 0 0-.2.202v1.298a.2.2 0 0 0 .2.202h.8v1.297c0 .258.101.505.282.687.18.182.425.284.68.284h.64c.255 0 .5-.102.68-.284a.975.975 0 0 0 .282-.687v-1.297h11.013v1.297c0 .258.101.505.282.687.18.182.425.284.68.284h.64c.255 0 .5-.102.68-.284a.975.975 0 0 0 .282-.687v-1.297h.293a.2.2 0 0 0 .142-.06.204.204 0 0 0 .058-.142v-1.298a.204.204 0 0 0-.127-.188.2.2 0 0 0-.078-.014z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.3 9c-2.485 0-4.5 2.1-4.5 4.608l-.224.01c-1.895.372-1.56 3.633-1.542 3.779a.2.2 0 0 0 .2.181l8.769-.02 8.768.02a.2.2 0 0 0 .2-.182l.002-.02c.027-.318.284-3.397-1.554-3.757h-.222C21.197 11.11 19.185 9 16.7 9h-5.4zm8.33 4.429c0-1.505-1.239-2.613-2.73-2.613h-5.8c-1.492 0-2.718 1.153-2.718 2.658v.067l-.007.093c-.004.01 0 .02 0 .03 0 .01-.004.02 0 .03.007.008-.01.015 0 .02.03.006-.01.006 0 .006l11.256.026c.01 0-.01-.003 0-.008.009-.005-.007-.012 0-.02v-.032c0-.01.005-.021 0-.03v-.227zM7.49 16.608a.896.896 0 0 1-.824-.556.908.908 0 0 1 .192-.981.89.89 0 0 1 1.215-.045.905.905 0 0 1-.237 1.511.885.885 0 0 1-.347.07zm12.732-.047a.892.892 0 0 1-.54-.509.903.903 0 0 1 .65-1.227.885.885 0 0 1 .915.382.907.907 0 0 1-.11 1.137.89.89 0 0 1-.915.217z"
});

var SvgUnknownCar = function SvgUnknownCar(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "currentColor",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUnknownCar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/unknown-car.51a2e871.svg";
export { ForwardRef as ReactComponent };